import { CycleUtils } from '@wix/package-picker-shared';
import { useCurrentModule } from '../components/ModuleProvider';
export const useShowsMonthlyUpsellNote = () => {
  const module = useCurrentModule();
  const {
    experiments
  } = module.internals.experiments.hooks.useExperiments();
  const {
    data: offeringDiscount,
    isLoading: isOfferingDiscountLoading
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchOfferingDiscount({});
  return !isOfferingDiscountLoading && experiments.isEnabled('monthlyNoteRedesign') && (offeringDiscount == null ? void 0 : offeringDiscount.hasSale) === false;
};
export const useShowsUpsellNoteForCycle = cycle => {
  const showsUpsellNote = useShowsMonthlyUpsellNote();
  return showsUpsellNote && Boolean(cycle && CycleUtils.isMonthly(cycle));
};
//# sourceMappingURL=useShowsMonthlyUpsellNote.js.map